import * as yup from 'yup';

import constants from 'Constants';
import i18n from 'i18n/config';
import { UnitsEnum } from 'modules/CreateNewRoomModal/AutoRemindersStepModal/utils';

import { getRemindersValidationTest } from './getRemindersValidationTest';
import { getScheduleDateValidationTest } from './getScheduleDateValidationTest';
import { getAliasValidation } from '../validationSchemas';

export const MAX_MINUTES = 59;
export const MAX_HOURS = 23;
export const MAX_DAYS = 120;

// NOTE: fn to make translations work
const getParticipantInput = () =>
  yup
    .string()
    .email(i18n.t('provide_a_valid_email'))
    .trim()
    .optional()
    .validEmailTld(i18n.t('provide_a_valid_email'))
    .emailIsNotDuplicateInArray(i18n.t('email_is_already_added'), 'participants');

export const getReminderSchema = () =>
  yup.object({
    amount: yup
      .number()
      .optional()
      .integer()
      .when('unit', {
        is: UnitsEnum.MINUTES,
        then: (schema) => schema.max(MAX_MINUTES, i18n.t('maximum_allowed_value', { count: MAX_MINUTES })),
      })
      .when('unit', {
        is: UnitsEnum.HOURS,
        then: (schema) => schema.max(MAX_HOURS, i18n.t('maximum_allowed_value', { count: MAX_HOURS })),
      }),
    unit: yup.mixed().oneOf(Object.values(UnitsEnum)).required(),
    enabled: yup.boolean().required(),
    isCustom: yup.boolean().required(),
  });

export const getCreateNewRoomSchema = (isAliasSupported: boolean) =>
  yup.object().shape({
    roomName: yup.string().required().min(3).max(50).trim(),
    roomAlias: isAliasSupported ? getAliasValidation() : yup.string().nullable().optional(),
    isWaitingListEnabled: yup.boolean().required(),
    startDate: yup.date().nullable().optional(),
    startTime: yup.date().nullable().optional(),
    endDate: yup.date().nullable().optional(),
    endTime: yup.date().nullable().optional(),
    timeZone: yup.number().required().min(-12).max(14),
    description: yup.string().max(constants.MAX_TOPIC_LENGTH).optional().trim(),
    participantInput: getParticipantInput(),
    participants: yup.array().of(getParticipantInput()).optional(),
    invitationMessage: yup.string().max(constants.MAX_INVITATIONS_MESSAGE_LENGTH).optional().trim(),
    reminders: yup.array().of(getReminderSchema()).optional().test(getRemindersValidationTest()),
  });

export const getCreateNewRoom = (isAliasSupported: boolean) =>
  getCreateNewRoomSchema(isAliasSupported).test(getScheduleDateValidationTest());
